(function($) {
  "use strict";
  $(function() {
    registerListener("load", setLazy);
    registerListener("load", lazyLoad);
    registerListener("scroll", lazyLoad);

    var lazy = [];
    var lazy_bg = [];

    function setLazy() {
      lazy = document.getElementsByClassName("lazy");
      lazy_bg = document.getElementsByClassName("lazy_bg");
    }

    function lazyLoad() {
      for (var i = 0; i < lazy.length; i++) {
        if (isInViewport(lazy[i])) {
          if (lazy[i].getAttribute("data-src")) {
            lazy[i].src = lazy[i].getAttribute("data-src");
            lazy[i].removeAttribute("data-src");
          }
        }
      }

      for (var i = 0; i < lazy_bg.length; i++) {
        if (isInViewport(lazy_bg[i])) {
          if (lazy_bg[i].getAttribute("data-src")) {
            lazy_bg[i].style = "background-image:url(" + lazy_bg[i].getAttribute("data-src") + ")";
            lazy_bg[i].removeAttribute("data-src");
          }
        }
      }

      cleanLazy();
      cleanLazyBg();
    }

    function cleanLazy() {
      lazy = Array.prototype.filter.call(lazy, function(l) {
        return l.getAttribute("data-src");
      });
    }

    function cleanLazyBg() {
      lazy_bg = Array.prototype.filter.call(lazy_bg, function(l) {
        return l.getAttribute("data-src");
      });
    }

    function isInViewport(el) {
      var rect = el.getBoundingClientRect();

      return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    function registerListener(event, func) {
      if (window.addEventListener) {
        window.addEventListener(event, func);
      } else {
        window.attachEvent("on" + event, func);
      }
    }
  });
})(jQuery);
